import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import React from "react";
import {
    footerContainer,
    footerImg,
    footerLink,
    footerLinkContainer,
} from "./footerStyles";

const Footer: React.FC = () => {
    return (
        <Box sx={footerContainer}>
            <Box
                component="img"
                src={"/images/icons/hsv-nxp-horizontal.png"}
                alt={"HSV NXP Logo"}
                sx={footerImg}
            />

            <Box sx={footerLinkContainer}>
                <Link
                    component={RouterLink}
                    to="/impressum"
                    sx={footerLink}
                >
                    Impressum
                </Link>
                <Link
                    component={RouterLink}
                    to="/datenschutz"
                    sx={footerLink}
                >
                    Datenschutz
                </Link>
            </Box>
        </Box>
    );
};

export default Footer;
